import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

const TARGETS: Record<string, string> = {
  home: "/",
  "silver-rate-india": "/silver-rate-india",
  "silver-india": "/silver-rate-india",
  gold: "/pakistan",
  india: "/india",
  pakistan: "/pakistan",
  fesco: "/check-fesco-bill",
  lesco: "/check-lesco-bill",
  mepco: "/check-mepco-bill",
  gepco: "/check-gepco-bill",
  pesco: "/check-pesco-bill",
  hesco: "/check-hesco-bill",
  iesco: "/check-iesco-bill",
  qesco: "/check-qesco-bill",
  sepco: "/check-sepco-bill",
  kelectric: "/check-kelectric-bill",
  sngpl: "/check-sngpl-bill",
  ssgc: "/check-ssgc-bill",
  ptcl: "/check-ptcl-bill",
};

const HOST = "drhint.com";

function buildRedirectUrl(path: string): string {
  if (typeof navigator === "undefined") return `https://${HOST}${path}`;
  const ua = navigator.userAgent || "";
  const isAndroid = /Android/i.test(ua);
  const isIOS = /iPhone|iPad|iPod/i.test(ua);
  const inApp = /(FBAN|FBAV|Instagram|Line|MicroMessenger|GSA|FB_IAB|FB4A|Snapchat|Twitter|TikTok|YouTube|com\.google\.android\.youtube|YouTubeMobile)/i.test(ua);

  const httpsUrl = `https://${HOST}${path}`;

  if (isAndroid && inApp) {
    return `intent://${HOST}${path}#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(httpsUrl)};end`;
  }
  if (isIOS && inApp) {
    // x-safari-https:// forces Safari to open on iOS from in-app browsers
    return `x-safari-https://${HOST}${path}`;
  }
  return httpsUrl;
}

export const Route = createFileRoute("/go/$target")({
  head: () => ({
    meta: [
      { title: "Opening drhint.com…" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: GoRedirect,
});

function GoRedirect() {
  const { target } = Route.useParams();
  const path = TARGETS[target] ?? "/";
  const httpsUrl = `https://${HOST}${path}`;

  useEffect(() => {
    const url = buildRedirectUrl(path);
    try {
      window.location.replace(url);
    } catch {
      window.location.href = url;
    }
    // iOS fallback: if x-safari-https failed silently, after 1.2s go to https
    const t = setTimeout(() => {
      if (document.visibilityState === "visible") {
        window.location.replace(httpsUrl);
      }
    }, 1200);
    return () => clearTimeout(t);
  }, [path, httpsUrl]);

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "system-ui, sans-serif", padding: 24, textAlign: "center" }}>
      <div>
        <p style={{ fontSize: 16, marginBottom: 12 }}>Opening drhint.com in your browser…</p>
        <p style={{ fontSize: 13, opacity: 0.7 }}>
          If nothing happens,{" "}
          <a href={httpsUrl} style={{ color: "#2563eb", textDecoration: "underline" }}>
            tap here to continue
          </a>
          .
        </p>
      </div>
    </div>
  );
}